export default "__VITE_ASSET__Bheetqgw__"